import React, { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import DateConverter from "@heartinz/date_and_time_processor";
import { useAuth } from "../../../context/AuthProvider";
import ReportView from "./ReportView";
import handleError from "../../../constants/handleError";
import AxiosInstance from "../../../utils/AxiosInstance";
import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import { usePermission } from "../../../context/PermissionContext";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";

const ViewSalesReport = ({ isData, isLoading, isActive }) => {
  const { isUser, updateSettings } = useAuth();
  const [reportModelOpen, setReportModelOpen] = useState(false);
  const [viewData, setViewData] = useState([]);
  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const { storeSettings } = usePermission();
  const [isViewTempModalOpen, setViewTempModalOpen] = useState(false);
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [selectTermalOption, setSelectTermalOption] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/sale/${saleId}`);
      const results = response.data.results;
      return results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateIdtemplateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewTempModalOpen(false);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSaleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
    // navigate(location.pathname, { replace: true, state: {} });
  };

  const handleSaleView = async (item) => {
    // if (item.trackmode === "SALE") {
    const data = await handleSaleItems(item.saleid);
    if (data) {
      setViewData(data);
      setViewModalOpen(true);
      setViewTempModalOpen(true);
    }
    // }
  };

  // const openSaleReportView = (item) => {
  //   setReportModelOpen(true);
  //   setViewData(item);
  // };
  const closeSaleReportView = () => {
    setReportModelOpen(false);
  };

  useEffect(() => {
    const id = storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  return (
    <>
      <div className="table-responsive rtable">
        <table className="table table-sm table-bordered text-center">
          <tbody>
            <tr>
              <td className="fw-600">SALES REPORT</td>
            </tr>
          </tbody>
        </table>

        <div className="d-flex rtable">
          <div className="w-50">
            <table className="table table-sm table-bordered">
              <tbody>
                <tr>
                  <td className="w-25">Name</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      isData?.reportInfo?.store?.title || ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">From Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.fromdate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.fromdate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">To Date</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : isData?.reportInfo?.todate ? (
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          isData?.reportInfo?.todate,
                          isUser?.timezone,
                        ),
                      ).date
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
                <tr>
                  <td className="w-25">No of Sales</td>
                  <td>
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `${isData?.reportSummary?.totalNoOfSale || 0}`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="w-10"></div>

          <div className="w-50 rtable">
            <table className="table table-sm table-bordered mb-0 text-center">
              <tbody>
                <tr>
                  <td className="w-25 fw-500">Base Total</td>
                  <td className="w-25 fw-500">GST Total</td>
                  <td className="w-25 fw-500">Grand Total</td>
                </tr>
                <tr>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalBasePrice) || 0,
                        "INR",
                      )}`
                    )}
                  </td>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.totalTaxAmount) || 0,
                        "INR",
                      )}`
                    )}
                  </td>
                  <td className="fw-600">
                    {isLoading ? (
                      <Skeleton variant="text" />
                    ) : (
                      `₹${CurrencyConverter.toCurrency(
                        Number(isData?.reportSummary?.grandTotal) || 0,
                        "INR",
                      )}`
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <table className="table table-sm table-bordered mb-3 rtable">
          <tbody>
            <tr>
              <td className="text-center">S No</td>
              <td className="text-center">No</td>
              <td className="text-center">Date</td>
              <td className="text-center">Time</td>
              <td className="text-center">Name</td>
              <td className="text-center">Phone</td>
              <td className="text-center">MRP</td>
              <td className="text-center">Discount</td>
              <td className="text-center">Sale Price</td>
              <td className="text-center">GST</td>
              <td className="text-center">Amount</td>
              {/* {isUser.stype === "MAIN" && (
                <td className="text-center">Generated By</td>
              )} */}
            </tr>
          </tbody>
          <tbody>
            {isLoading ? (
              [...Array(11)].map((_, index) => (
                <tr key={index}>
                  {[...Array(10)].map((__, i) => (
                    <td key={i} className="text-center">
                      <Skeleton variant="text" width={i === 0 ? 300 : 200} />
                    </td>
                  ))}
                </tr>
              ))
            ) : Array.isArray(isData?.reportData) &&
              isData?.reportData?.length > 0 ? (
              isData?.reportData?.map((item, index) => (
                <tr
                  key={item?._id || index}
                  className="position-relative  cursor-poInter hover-row"
                  onClick={() => handleSaleView(item)}
                >
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{item?.saleno}</td>
                  {/* <td className="text-center">
                    {
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          item?.saledate,
                          isUser?.timezone
                        )
                      ).date
                    } 
                  </td> */}
                  <td className="text-center">
                    <div className="d-flex flex-column">
                      <span className="text-nowrap text-heading fw-medium">
                        {
                          DateConverter.ISOToDisplayFormat(
                            DateConverter.convertToTimeZone(
                              item.saledate,
                              isUser.timezone,
                            ),
                          ).date
                        }
                      </span>
                      {/* <span className="text-nowrap">
                        <small>
                          {
                            DateConverter.ISOToDisplayFormat(
                              DateConverter.convertToTimeZone(
                                item.saledate,
                                isUser.timezone,
                              ),
                            ).time
                          }
                        </small>
                      </span> */}
                    </div>
                  </td>
                  <td className="text-center">
                    {
                      DateConverter.ISOToDisplayFormat(
                        DateConverter.convertToTimeZone(
                          item.saledate,
                          isUser.timezone,
                        ),
                      ).time
                    }
                  </td>
                  <td className="text-center">
                    {item?.saleto?.customername
                      ? `${item?.saleto?.customername}`
                      : "-"}
                  </td>
                  <td className="text-center">
                    {item?.saleto?.customerphone
                      ? `+91 ${item?.saleto?.customerphone}`
                      : " - "}
                  </td>
                  <td className="text-center">
                    ₹{CurrencyConverter.toCurrency(item?.totalMrp || 0, "INR")}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item?.totalDiscount || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      item?.totalSoldPrice || 0,
                      "INR",
                    )}
                  </td>
                  <td className="text-center">
                    ₹{CurrencyConverter.toCurrency(item?.taxamount || 0, "INR")}
                  </td>

                  <td className="text-center">
                    ₹
                    {CurrencyConverter.toCurrency(
                      Number(item?.totalamount) || 0,
                      "INR",
                    )}
                  </td>
                  {/* {isUser.stype === "MAIN" && (
                    <td className="text-center">
                      {item.saleby?.storename || ""}
                    </td>
                  )} */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="text-center p-2">
                  <small className="text-muted">
                    No sale found in the store. add some customers to get
                    started.
                  </small>
                </td>
              </tr>
            )}
          </tbody>
          <tbody>
            <tr>
              <td colSpan="6" className="text-center"></td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.totalMrp || 0,
                    "INR",
                  )}`
                )}
              </td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.totalDiscount || 0,
                    "INR",
                  )}`
                )}
              </td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData.reportSummary?.totalSoldPrice || 0,
                    "INR",
                  )}`
                )}
              </td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.totalTaxAmount || 0,
                    "INR",
                  )}`
                )}
              </td>
              <td className="text-center fw-600">
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    isData?.reportSummary?.grandTotal || 0,
                    "INR",
                  )}`
                )}
              </td>
            </tr>
          </tbody>
        </table>

        <table className="table table-sm table-bordered mb-0 rtable w-30">
          <tbody>
            <tr>
              <td className="w-25">Cash</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.reportSummary?.totalCash) || 0,
                    "INR",
                  )}`
                )}
              </td>
            </tr>
            <tr>
              <td className="w-25">Card</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.reportSummary?.totalCard) || 0,
                    "INR",
                  )}`
                )}
              </td>
            </tr>
            <tr>
              <td className="w-25">Online Pay</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.reportSummary?.totalOnline) || 0,
                    "INR",
                  )}`
                )}
              </td>
            </tr>
            <tr>
              <td className="w-25">UPI</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.reportSummary?.totalUpi) || 0,
                    "INR",
                  )}`
                )}
              </td>
            </tr>
            <tr>
              <td className="w-25">PayLater</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.reportSummary?.totalPaylater) || 0,
                    "INR",
                  )}`
                )}
              </td>
            </tr>
            <tr>
              <td className="w-25">WaveOff</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.reportSummary?.totalWaveoff) || 0,
                    "INR",
                  )}`
                )}
              </td>
            </tr>
            {/* <tr>
              <td className="w-25">Discount</td>
              <td>
                {isLoading ? (
                  <Skeleton variant="text" />
                ) : (
                  `₹${CurrencyConverter.toCurrency(
                    Number(isData?.reportSummary?.totalDiscount) || 0,
                    "INR"
                  )}`
                )}
              </td>
            </tr> */}
          </tbody>
        </table>
      </div>

      {!templateId && isViewTempModalOpen && (
        <InvoiceTempPreview
          isData={viewData}
          onClose={() => setViewTempModalOpen(false)}
          onAdd={handleSetTemplate}
        />
      )}
      {templateId && isViewModalOpen && (
        <TemplateModalLayout
          isOpen={isViewModalOpen}
          isData={viewData}
          onClose={handleSaleClose}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          setSaleData={setViewData}
          isActive={isActive}
        />  
      )}

      {reportModelOpen && (
        <ReportView onClose={closeSaleReportView} viewData={viewData} />
      )}
    </>
  );
};

export default ViewSalesReport;
